<template>
  <div>
    <!-- 兑换码礼包编辑框 -->
    <EditRedeemCodeGiftDialog v-if="visible('EditRedeemCodeGiftDialog')" />
    <!-- 新增兑换码编辑框 -->
    <AddRedeemCodeDialog v-if="visible('AddRedeemCodeDialog')" />
    <!-- 兑换码礼包详情弹窗 -->
    <RedeemCodeGiftDetailsDialog
      v-if="visible('RedeemCodeGiftDetailsDialog')"
    />
  </div>
</template>

<script>
import EditRedeemCodeGiftDialog from "@/pages/redeem-code/EditRedeemCodeGiftDialog";
import AddRedeemCodeDialog from "@/pages/redeem-code/AddRedeemCodeDialog";
import RedeemCodeGiftDetailsDialog from "@/pages/redeem-code/RedeemCodeGiftDetailsDialog";

export default {
  components: {
    EditRedeemCodeGiftDialog,
    AddRedeemCodeDialog,
    RedeemCodeGiftDetailsDialog,
  },
  methods: {
    visible(name) {
      if (this.$dialogutil.visible(name) == undefined) {
        this.$dialogutil.registerModule(name);
      }
      return this.$dialogutil.visible(name);
    },
  },
};
</script>
